import React, { memo } from 'react';
import PropTypes from 'prop-types';

function BrandRadarControls({ onZoomIn, onZoomOut, onReset }) {
  return (
    <div className="BrandRadar-controls">
      <button
        type="button"
        className="BrandRadar-control-btn"
        onClick={onZoomIn}
        aria-label="확대"
      >
        +
      </button>
      <button
        type="button"
        className="BrandRadar-control-btn"
        onClick={onZoomOut}
        aria-label="축소"
      >
        −
      </button>
      <button
        type="button"
        className="BrandRadar-control-btn"
        onClick={onReset}
        aria-label="화면 위치 초기화"
      >
        ⟳
      </button>
    </div>
  );
}

BrandRadarControls.propTypes = {
  onZoomIn: PropTypes.func.isRequired,
  onZoomOut: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
};

export default memo(BrandRadarControls);
